module.exports = __webpack_public_path__ + "img/inktober_2020_31_crawl.0fc7df1e.jpg";